/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__Question_4Inputs */

const en_help_center__payments_n_refunds__question_4 = /** @type {(inputs: Help_Center__Payments_N_Refunds__Question_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if I win? How much do I pay total?`)
};

/**
* | output |
* | --- |
* | "What if I win? How much do I pay total?" |
*
* @param {Help_Center__Payments_N_Refunds__Question_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__question_4 = /** @type {((inputs?: Help_Center__Payments_N_Refunds__Question_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__Question_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__question_4(inputs)
});